__turbopack_context__.v({
  "nav-context": "index-module__UR7Osq__nav-context",
  "nav-link": "index-module__UR7Osq__nav-link",
  "nav-link-active": "index-module__UR7Osq__nav-link-active",
});
